import { z } from 'zod/v4';

import { metricLogSchema } from './metric-log.schema';

export const copilotLogListSchema = z.object({
  externalId: z.string(),
  logs: z.array(metricLogSchema),
});

export type CopilotLogList = z.infer<typeof copilotLogListSchema>;
